import { FC, useState } from "react";
import { useGetUserQuery } from "entities/user";
import { TWO_FACTOR_PROVIDERS } from "../model/providers";
import { TwoFactorBadgeState, TwoFactorProvider } from "../model/types";
import { TwoFactorAuthButton } from "./TwoFactorAuthButton";
import { TelegramLinkModal } from "./TelegramLinkModal";
import { TelegramUnlinkModal } from "./TelegramUnlinkModal";
import { WhatsappPhoneModal } from "./WhatsappPhoneModal";

import styles from "./TwoFactorAuthList.module.css";

type ModalState = "telegram-link" | "telegram-unlink" | "whatsapp-phone" | null;

export const TwoFactorAuthList: FC = () => {
  const { data } = useGetUserQuery();
  const [modal, setModal] = useState<ModalState>(null);

  const getStatus = (provider: TwoFactorProvider): TwoFactorBadgeState => {
    if (provider === "telegram") {
      return data?.telegram_2fa?.linked ? "linked" : "none";
    }

    const status = data?.whatsapp_2fa?.status;
    if (status === "verified") return "linked";
    if (status === "pending") return "pending";
    return "none";
  };

  const handleClick = (provider: TwoFactorProvider) => {
    if (provider === "telegram") {
      setModal(getStatus(provider) === "linked" ? "telegram-unlink" : "telegram-link");
    } else if (getStatus(provider) !== "linked") {
      setModal("whatsapp-phone");
    }
  };

  return (
    <div className={styles.list}>
      {TWO_FACTOR_PROVIDERS.map(({ provider, label, Icon, available }) => (
        <TwoFactorAuthButton
          key={provider}
          label={label}
          icon={<Icon width={28} height={28} />}
          status={getStatus(provider)}
          disabled={!available}
          onClick={() => handleClick(provider)}
        />
      ))}

      {modal === "telegram-link" && (
        <TelegramLinkModal onClose={() => setModal(null)} />
      )}
      {modal === "telegram-unlink" && (
        <TelegramUnlinkModal onClose={() => setModal(null)} />
      )}
      {modal === "whatsapp-phone" && (
        <WhatsappPhoneModal
          onClose={() => setModal(null)}
          pendingPhoneMasked={data?.whatsapp_2fa?.phone_masked}
        />
      )}
    </div>
  );
};
